import { call, put, select } from 'redux-saga/effects'
import { http_resolve_fpool_fastquote, http_resolve_fpool_special } from 'src/http'
import { dict, fitem_t, fpool_special, option_t, saga_act } from 'src/types'
import { find_fitem, find_fitem_idx, sort_fpool, to_formik_item } from 'src/utils'

import { shoot } from '../actions'
import { select_formik_pool } from '../store'
import { saga_do_request } from './base.saga'

/**
 * Resolve fpool special/fastquote
 */
export function* saga_resolve_fpool(action: saga_act, fastquote?: boolean): unknown {
  const curr_whole: fitem_t[] = yield select(select_formik_pool)
  const curr_general = curr_whole?.filter(({ sector }) => sector === '*')

  yield put(shoot.reduce_formik_pool(sort_fpool(curr_general)))

  const fp_special: fpool_special = yield call(
    saga_do_request,
    fastquote ? http_resolve_fpool_fastquote : http_resolve_fpool_special,
    action
  )
  if (fp_special?.formItems) {
    const next_special = fp_special?.formItems?.map(to_formik_item) || []

    // Residence/PRA municipality dependencies
    const ipro = find_fitem_idx(next_special, 'province')
    const imun = find_fitem_idx(next_special, 'municipality')

    if (ipro !== -1 && imun !== -1) {
      const provinces = next_special[ipro]?.options || []
      const municipas = next_special[imun]?.options || []
      const deps: dict<option_t[]> = {}
      provinces?.forEach(({ key: province }) => {
        deps[province] = [
          ...municipas.filter(({ val }) => val?.split('-')?.[0] === province),
          { key: '?', val: 'ALTRI' },
        ]
      })
      const sector_descr = next_special[ipro]?.sector_descr
      const depend_descr = sector_descr === 'car' ? 'residence_municipality' : 'pra_municipality'
      next_special[ipro].dependencies = {
        ...next_special[ipro]?.dependencies,
        '*': {
          ...next_special[ipro]?.dependencies?.['*'],
          domains: {
            [`ts2__${sector_descr}__${depend_descr}`]: deps,
          },
        },
      }
    }

    // Residence CAP dependencies
    const ires = find_fitem_idx(next_special, '__residence_cap')
    if (imun !== -1 && ires !== -1) {
      const caps = next_special[ires]?.options || []

      const d1: dict<dict<dict<string>>> = {}
      next_special[imun]?.options?.forEach(({ key }) => {
        d1[key] = { precompiled: { [`ts5__${next_special[ires]?.sector_descr}__cap`]: '' } }
      })
      next_special[imun].dependencies = {
        ...next_special[imun]?.dependencies,
        '*': {
          ...next_special[imun]?.dependencies?.['*'],
          domains: {
            [`ts2__${next_special[ires]?.sector_descr}__residence_cap`]: {
              F205: caps?.filter(({ val }) => val?.split('-')?.[1] === 'MI'),
              H501: caps?.filter(({ val }) => val?.split('-')?.[1] === 'RM'),
            },
          },
        },
      }
      const d2: dict<dict<dict<string>>> = {}
      next_special[ires]?.options?.forEach(({ key }) => {
        d2[key] = { precompiled: { [`ts5__${next_special[ires]?.sector_descr}__cap`]: key } }
      })
      next_special[ires].dependencies = {
        ...next_special[ires]?.dependencies,
        ...d2,
      }
    }

    // Entity init
    if (action?.args?.entity) {
      const ie = find_fitem_idx(next_special, '__entity')
      if (ie !== -1) {
        next_special[ie].capture = String(action?.args?.entity)
      }
    }

    if (fastquote) {
      // Email init
      const ie = find_fitem_idx(next_special, '__email')
      if (ie !== -1) {
        next_special[ie].capture = find_fitem(curr_general, 'fs1a__email')?.capture
      }
      // Privacy init
      const ip = find_fitem_idx(next_special, '__privacy')
      if (ip !== -1) {
        next_special[ip].capture = 'true'
      }
      // ITAS class
      const it = find_fitem_idx(fp_special?.formItems, '__itas_class')
      if (it !== -1) {
        yield put(shoot.reduce_history_item('itas-class', fp_special?.formItems?.[it]?.capture))
      }
    }

    yield put(shoot.reduce_formik_pool(sort_fpool([...curr_general, ...next_special])))
    yield put(shoot.reduce_metadata(fp_special?.metadata))
  }
}
